import './forms.scss';
import { initGformButtons } from '../../../assets/src/ts/utils/gform-buttons';

initGformButtons();
